import React from "react";
import { Link, useLocation } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

export default function Navbar({ onFiltersClick }) {
  const location = useLocation();
  const token = localStorage.getItem("token");

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  return (
    // Changed bg-dark to custom-navbar
    <nav className="navbar navbar-expand-lg navbar-dark custom-navbar sticky-top px-4 py-3">
      <Link className="navbar-brand fw-bold fs-4 d-flex align-items-center gap-2" to={token ? "/" : "/login"}>
        <i className="bi bi-box-seam-fill"></i> Sukhram Corp
      </Link>

      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navContent"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse justify-content-end" id="navContent">
        <div className="d-flex align-items-center gap-2">
          {token && onFiltersClick && (
            <button className="btn btn-outline-light btn-sm" onClick={onFiltersClick}>
              <i className="bi bi-funnel"></i> Filters
            </button>
          )}

          {token && (
            <>
            <Link
              className={`btn btn-sm ${location.pathname === "/products/add" ? "btn-light text-dark" : "btn-outline-light"}`}
              to="/products/add"
            >
              <i className="bi bi-plus-lg"></i> Product
            </Link>
            <Link
              className={`btn btn-sm ${location.pathname === "/manage-models" ? "btn-light text-dark" : "btn-outline-light"}`}
              to="/manage-models"
            >
              <i className="bi bi-cog"></i> Manage Models
            </Link>
            </>
          )}

          {token && (
            <button className="btn btn-danger btn-sm ms-2" onClick={handleLogout}>
              Logout
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}